<template>
  <div class="error-overlay" v-if="error">
    <div class="error-overlay__popup">
			<div class="error-overlay__title" v-if="error.response && error.response.status">
				{{error.response.status}}
			</div>
			<div class="error-overlay__request" v-if="error.config && error.config.url">{{error.config.url}}</div>
      <div class="error-overlay__error">
        {{errorMessage}}
      </div>

      <p>
      {{resource('refreshMessage')}}
      </p>
      <button class="error-overlay__button button--primary" @click="refresh()">
				<Icon class="button__icon" name="retry" />
				<div class="button__label">{{resource('refreshButton')}}</div>
			</button>
    </div>
  </div>
</template>
<style lang="scss">
.error-overlay{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1337;
	background: $overlay;
  &__popup{
		background: $overlay__bg;
		padding:20px;
	}
	&__title{
		font-size: $h1;
		font-weight: bold;
		margin-bottom: $fs-2;
	}
	&__error{
		border:1px solid $error;
		color:$error;
		background:#fee;
		padding:5px;
		max-height: 50vh;
		max-width: 80vw;
		overflow: auto;
	}
	&__request{
		font-size: $fs-2;
		margin-bottom: $fs-2;
	}
	&__button.button--primary{
		display: flex;
		margin-left:auto;
	}
}
</style>
<script>
import Icon from '@/components/icon'
export default {
	name: 'errorOverlay',
	components:{
		Icon
	},
	model:{
		prop: 'error'
	},
	props:{
		error:{
			type: Error,
			default(){
				return {}
			}
		}
	},
	methods:{
		resource(item) {
			var lang = this.$store.getters.language
			return this.res[lang][item]
		},
		refresh(){
			location.reload()
		}
	},
	computed: {
		errorMessage(){
			return this.error
		},
		lang() {
			return this.$store.getters.language
		},
	},
	data(){
		return{
			res:{
				nl:{
					refreshMessage: 'Druk op de knop om de applicatie te verversen',
					refreshButton: 'Verversen'
				},
				fr:{
					refreshMessage: 'Appuyez sur le bouton pour actualiser l\'application',
					refreshButton: 'Actualiser'
				}
			}
		}
	}
}
</script>
